// packages/shared-hooks/src/clients/useRestoreClientLegalEntity.ts
//
// `POST /clients/:id/legal-entities/:legalEntityId/restore` —
// un-archives a legal entity. Backend rejects with 409 when the entity's
// INN is now claimed by a different active row.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ClientLegalEntitySchema, type ClientLegalEntity } from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { clientsKeys } from './keys.js';

export function useRestoreClientLegalEntity(clientId: string, legalEntityId: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<ClientLegalEntity, unknown, void>({
    mutationFn: () =>
      client.post<ClientLegalEntity>(
        `/clients/${clientId}/legal-entities/${legalEntityId}/restore`,
        undefined,
        {},
        ClientLegalEntitySchema,
      ),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: clientsKeys.detail(clientId) });
      void qc.invalidateQueries({ queryKey: clientsKeys.all });
    },
  });
}
